export default "__VITE_ASSET__10245195__"